module.exports = __webpack_public_path__ + "static/img/QLD-21.6824012.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/QLD-21.jpg
// module id = ajDp
// module chunks = 0